// extracted by mini-css-extract-plugin
module.exports = {"SkeletonOpportunity":"_3bJrXUSK","opportunityDataArea":"_3JcTWfGk","skeletonInfo":"F-PbwLKv","skeletonAvatar":"_2ctDhij2","skeletonBar":"AbWnIMzH"};